<template>
    <modal ref="modal" :title="title" v-if="file" :close_on_focus="false">
        <div class="form-group row">
            <div class="col-12">
                <input placeholder="Name" class="form-control main-modal--input" type="text" v-model="name">
            </div>
        </div>
        <div class="form-group row">
            <div class="col-12">
                <textarea placeholder="Description" class="form-control main-modal--input" rows="5" style="resize: none" v-model="description"></textarea>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-12">
                <textarea placeholder="Comments" class="form-control main-modal--input" rows="5" style="resize: none" v-model="comments"></textarea>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-12 d-flex justify-content-around">
                <a href="javascript:void(0)" class="btn btn-secondary px-2 " v-bind:disabled="uploading" v-on:click="cancel()">Delete</a>
                <a href="javascript:void(0)" class="btn btn-primary px-2 d-flex" v-bind:disabled="uploading" v-on:click="upload()">
                    Save
                    <div v-if="uploading" class="loaders--small ml-2"></div>
                </a>
            </div>
        </div>
    </modal>
</template>

<script>
	import Modal from "../general_components/Modal";
	export default {
		name: "UploadFileModal",
		components: {Modal},
        props: [
			'title',
            'upload_url'
        ],

        data(){
			return {
				file: null,

                name: '',
                description: '',
                comments: '',

				uploading: false,
            }
        },

        methods: {
			open(file){
				if (!file) return;

				this.file = file;
				this.name = file.name;
				this.description = '';
				this.comments = '';

				this.$nextTick(function (){
					this.$refs.modal.openModal();
                });
            },

            upload(){
				let
					form_data = new FormData(),
					_this = this;

				form_data.append('file', _this.file);
				form_data.append('name', _this.name);
				form_data.append('description', _this.description);
				form_data.append('comments', _this.comments);

				_this.uploading = true;

				axios.post(_this.upload_url, form_data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})
					.then(function (response) {
						_this.$emit('uploaded', response.data);
						_this.uploading = false;
						_this.$refs.modal.closeModal(null, true);
					})
					.catch(function (error) {
                        Vue.$toast.open({
                            message: 'Failed to upload the file',
                            type: 'error'
                        });
						_this.uploading = false;
					})
            },

            cancel(){
				this.$refs.modal.closeModal(null, true);
            }
        }
	}
</script>
